import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Form, Input, Popover } from 'antd'

const Item = Form.Item

export default class ConsultingAdd extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    static propTypes = {
        modalform: PropTypes.func.isRequired,
        item: PropTypes.object.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        // 將form對象透過modalform()傳遞給父組件
        this.props.modalform(this.fm)
    }

    render() {
        const { serviceTitle, serviceDescription, serviceDepartment, serviceStaffName, serviceTelephone,  handlingTime, applicableObjects } = this.props.item
        const formItemLayout = {
            labelCol: {
                xs: {
                    span: 24,
                },
                sm: {
                    span: 4,
                },
            },
            wrapperCol: {
                xs: {
                    span: 24,
                },
                sm: {
                    span: 16,
                },
            },
        };
        return (
            <div>
                <Form
                    ref={this.fm}
                    {...formItemLayout}
                >
                    <Item
                        label={<Popover content={'可於公開頁中以關鍵字模糊查詢'} title="說明"><span style={{color:'red'}}>諮詢項目</span></Popover>}
                        name="serviceTitle"
                        initialValue={serviceTitle}
                        rules={[
                            { required: true, message: '必填' },
                        ]}
                    >
                        <Input placeholder='XX處OO組負責「******」業務是誰呢?' />
                    </Item>
                    <Item
                        label={<Popover content={'可被公開頁中以關鍵字模糊查詢'} title="說明"><span style={{color:'red'}}>作業內容</span></Popover>}
                        name="serviceDescription"
                        initialValue={serviceDescription}
                        rules={[
                            { required: true, message: '必填' },
                        ]}
                    >
                        <Input.TextArea />
                    </Item>
                    <Item
                        label="服務單位"
                        name="serviceDepartment"
                        initialValue={serviceDepartment}
                        rules={[
                            { required: true, message: '必填' },
                        ]}
                    >
                        <Input placeholder='XX處OO組/**中心' />
                    </Item>
                    <Item
                        label="承辦人"
                        name="serviceStaffName"
                        initialValue={serviceStaffName}
                        rules={[
                            { required: true, message: '必填' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="連絡電話"
                        name="serviceTelephone"
                        initialValue={serviceTelephone}
                        rules={[
                            { required: true, message: '必填' },
                        ]}
                    >
                        <Input placeholder='062532106#分機' />
                    </Item>
                    <Item
                        label="處理時間"
                        name="handlingTime"
                        initialValue={handlingTime}
                        rules={[
                            { required: true, message: '必填' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                    <Item
                        label="服務對象"
                        name="applicableObjects"
                        initialValue={applicableObjects}
                        rules={[
                            { required: true, message: '必填' },
                        ]}
                    >
                        <Input placeholder='' />
                    </Item>
                </Form>
            </div>
        )
    }
}